module.exports = __webpack_public_path__ + "static/media/user_1.7dafcfd7.jpg";